(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9748],{

/***/ 786350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ZeroCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function ZeroCart(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 226.768,
        height: props.height || 184.32,
        viewBox: "0 0 226.768 184.32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: ".prefix__b{fill:#bfbfbf}.prefix__c{fill:#b1b1b1}.prefix__d{fill:#28384f}.prefix__e{fill:#fff}"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                transform: "translate(8679.17 -11063)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M-8470.978 11105.794h-85.675a5.952 5.952 0 110-11.9h12.574a15.445 15.445 0 0015.445-15.445 15.453 15.453 0 00-15.445-15.449H-8649.3a15.453 15.453 0 00-15.445 15.445 15.445 15.445 0 0015.445 15.446h44.439a5.952 5.952 0 110 11.9h-12.087a18.576 18.576 0 00-18.576 18.576 18.576 18.576 0 0018.576 18.576h78.258a5.946 5.946 0 01.231 11.889h-123.9a16.816 16.816 0 00-16.811 16.82 16.816 16.816 0 0016.816 16.809h36.691a5.952 5.952 0 01.88 11.831h-5.93a16.814 16.814 0 100 33.629h117.85a16.814 16.814 0 100-33.629h-10.244a5.952 5.952 0 01.88-11.831h36.59a16.809 16.809 0 0016.809-16.809 16.816 16.816 0 00-16.809-16.816h-5.05a5.946 5.946 0 01.231-11.889h19.478a18.576 18.576 0 0018.578-18.577 18.576 18.576 0 00-18.578-18.576zm-93.5 88.618a5.944 5.944 0 01-5.05 5.88h-8.794a5.952 5.952 0 01.88-11.831h7.012a5.952 5.952 0 015.95 5.951z",
                        fill: "#f4f4f4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        className: "prefix__b",
                        width: 123.361,
                        height: 10.821,
                        rx: 5.411,
                        transform: "translate(-8627.467 11236.499)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        className: "prefix__b",
                        width: 23.929,
                        height: 10.821,
                        rx: 5.411,
                        transform: "translate(-8659.626 11236.499)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "prefix__c",
                        d: "M-8493.009 11247.32h.39a5.411 5.411 0 01-5.411-5.411 5.411 5.411 0 015.411-5.411h-.39a5.4 5.4 0 015.4 5.411 5.4 5.4 0 01-5.4 5.411z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        transform: "translate(-8657.581 11112.776)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M142.779 88.601h-93.68l-10.91-74.1h118.268zm-89.1-5.288h84.7l11.72-63.488H44.314z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M44.963 36.323h104.605v2.886H44.963zM49.298 64.062h95.933v2.886H49.298z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M95.821 17.147h2.886v68.808h-2.886zM62.018 17.293l2.87-.298L72.036 85.8l-2.87.298zM121.178 85.778l8.458-68.843 2.866.352-8.458 68.843zM39.407 21.571L26.766 9.011h-16.72v-9h20.42l15.283 15.184z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M136.697 113.521H51.044a17.025 17.025 0 110-34.051h.354v9h-.346a8.029 8.029 0 100 16.051h85.646z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__d",
                                cx: 16.01,
                                cy: 16.01,
                                r: 16.01,
                                transform: "rotate(-80.8 133.624 -5.902)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__e",
                                cx: 8.029,
                                cy: 8.029,
                                r: 8.029,
                                transform: "rotate(-89 126.043 -4.47)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__d",
                                cx: 15.965,
                                cy: 15.965,
                                r: 15.965,
                                transform: "rotate(-80.73 90.744 43.839)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__e",
                                cx: 8.029,
                                cy: 8.029,
                                r: 8.029,
                                transform: "rotate(-80.75 91.438 35.213)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M20.73 9.01H4.505a4.505 4.505 0 110-9.01h16.232a4.5 4.5 0 010 9z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}


/***/ }),

/***/ 329748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B2bRfqFormModal": function() { return /* binding */ B2bRfqFormModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
// EXTERNAL MODULE: ./src/redux/reducers/index.ts + 19 modules
var reducers = __webpack_require__(950682);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(727484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(561903);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(690948);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/Textfield/StyledTextField.js


var StyledTextField = (0,styled/* default */.ZP)(TextField/* default */.Z)({
    "& label.Mui-focused": {
        color: "#999999"
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "#E4E4E4"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#E4E4E4"
        },
        "&:hover fieldset": {
            borderColor: "#E4E4E4"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#E4E4E4"
        }
    },
    "& .MuiOutlinedInput-input": {
        height: 48
    }
});

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/Textfield/index.js


// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/MobileDateTimePicker/MobileDateTimePicker.js + 65 modules
var MobileDateTimePicker = __webpack_require__(652878);
;// CONCATENATED MODULE: ./src/components/DateTimePicker/DateTimePicker.js


var StyledDateTimePicker = (0,styled/* default */.ZP)(MobileDateTimePicker/* MobileDateTimePicker */.W)({
    "& label": {
        fontFamily: "Montserrat"
    },
    "& label.Mui-focused": {
        color: "#999999"
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "#E4E4E4"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#E4E4E4"
        },
        "&:hover fieldset": {
            borderColor: "#E4E4E4"
        },
        "&.Mui-focused fieldset": {
            borderColor: "#E4E4E4"
        }
    },
    "& .MuiOutlinedInput-input": {
        height: 48,
        fontFamily: "Montserrat",
        fontWeight: 400,
        fontSize: 14,
        fontStyle: "normal"
    }
});

;// CONCATENATED MODULE: ./src/components/DateTimePicker/index.js


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(450594);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(804160);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var actions_storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./src/containers/ProductDescription/Components/B2b/B2b.module.scss
var B2b_module = __webpack_require__(206723);
var B2b_module_default = /*#__PURE__*/__webpack_require__.n(B2b_module);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/AdapterDayjs.js
var AdapterDayjs = __webpack_require__(510586);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var LocalizationProvider = __webpack_require__(550720);
// EXTERNAL MODULE: ./src/utils/handleB2bCart.js
var handleB2bCart = __webpack_require__(471822);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/assets/svgExports/ZeroCart.js
var ZeroCart = __webpack_require__(786350);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(586423);
// EXTERNAL MODULE: ./src/utils/canDisablePlaceOrder.ts
var canDisablePlaceOrder = __webpack_require__(596930);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/B2b/B2bRfqFormModal.js




















// import Textarea from '@mui/joy/Textarea';





var INITIAL_RFQ_FORM_STATE = {
    name: "",
    phone: "",
    email: "",
    custom_message: "",
    address: "",
    date_and_time: "",
    gst: ""
};
var ONLY_NUMERIC_TYPE = /[^0-9]/g;
var isMobile = deviceWidth/* deviceWidth */.o < constants/* MAX_MOBILE_WIDTH */.Cf;
var B2bRfqFormModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref8 = (0,react.useState)(INITIAL_RFQ_FORM_STATE), rfqFormState = ref8[0], setRfqFormState = ref8[1];
    var ref9 = (0,reducers/* useSelector */.v)(function(state) {
        return {
            b2bRfqInputFields: state.storeReducer.b2bRfqInputFields,
            cartData: state.cartReducer,
            openRfqFormModal: state.storeReducer.openRfqFormModal
        };
    }), b2bRfqInputFields = ref9.b2bRfqInputFields, cartData = ref9.cartData, openRfqFormModal = ref9.openRfqFormModal;
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    (0,react.useEffect)(function() {
        if (openRfqFormModal) {
            var ref;
            if (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.rfq_details) === null || ref === void 0 ? void 0 : ref.name) {
                setRfqFormState(cartData === null || cartData === void 0 ? void 0 : cartData.rfq_details);
            }
        }
    }, [
        openRfqFormModal
    ]);
    var validateEmail = function(email) {
        return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };
    var validateGST = function(gst) {
        var gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        return gstPattern.test(gst);
    };
    var handleSubmitBtnClick = function() {
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        var rfqFormStateObjKeys = Object.keys(rfqFormState);
        var isInputValid = rfqFormStateObjKeys.every(function(stateKey) {
            var searchedInputObj = b2bRfqInputFields.find(function(b2bInputField) {
                return b2bInputField.payload_key === stateKey;
            });
            if (searchedInputObj.is_mandatory && !rfqFormState[stateKey].trim()) {
                (0,Toast/* toastNotifyError */.Lu)("Please fill ".concat(searchedInputObj.inputLabel));
                return false;
            }
            return true;
        });
        if (!isInputValid) {
            return;
        }
        var regexExp = /^[6-9]\d{9}$/gi; // Regular expression to check if string is a Indian mobile number
        if (!regexExp.test(rfqFormState.phone)) {
            (0,Toast/* toastNotifyError */.Lu)("Please enter valid Phone Number");
            return;
        }
        if (rfqFormState.email && !validateEmail(rfqFormState.email)) {
            (0,Toast/* toastNotifyError */.Lu)("Please enter valid email");
            return;
        }
        if (rfqFormState.gst && !validateGST(rfqFormState.gst)) {
            (0,Toast/* toastNotifyError */.Lu)("Please Enter a Valid GST");
            return;
        }
        var isItemQuantityGreaterThanMinOrderQuantity = false;
        cartData.items.forEach(function(item) {
            var ref;
            if (item === null || item === void 0 ? void 0 : (ref = item.variants_selected) === null || ref === void 0 ? void 0 : ref.length) {
                item === null || item === void 0 ? void 0 : item.variants_selected.forEach(function(variant) {
                    var ref;
                    if (!variant.quantity || variant.quantity < ((variant === null || variant === void 0 ? void 0 : (ref = variant.b2b_pricing_info) === null || ref === void 0 ? void 0 : ref.minimum_order_quantity) || 1)) {
                        isItemQuantityGreaterThanMinOrderQuantity = true;
                    }
                });
            } else {
                var ref1;
                if (!item.quantity || item.quantity < ((item === null || item === void 0 ? void 0 : (ref1 = item.b2b_pricing_info) === null || ref1 === void 0 ? void 0 : ref1.minimum_order_quantity) || 1)) {
                    isItemQuantityGreaterThanMinOrderQuantity = true;
                }
            }
        });
        if (isItemQuantityGreaterThanMinOrderQuantity) {
            (0,Toast/* toastNotifyError */.Lu)("Please enter Quantity greater than or equal to Item's Minimum Order Quantity");
            return;
        }
        var newCartData = cartData;
        newCartData.order_mode = 3;
        newCartData.order_type = 0;
        newCartData.store_id = storeInfo.store_id;
        newCartData.prepaid_flag = 0;
        newCartData.buyer_pay_value = 0;
        newCartData.amount = 0;
        newCartData.items_total = 0;
        newCartData.pay_amount = 0;
        newCartData.payment_offer = {};
        newCartData.store_offer = {};
        newCartData.delivery_info = {};
        newCartData.delivery_charge = 0;
        newCartData.extra_charges = 0;
        newCartData.total_gst_paid = 0;
        newCartData.rfq_details = (0,_object_spread/* default */.Z)({}, rfqFormState);
        dispatch((0,cart/* setB2bCart */.i5)(newCartData, function(data) {
            dispatch((0,cart/* saveCart */.FP)(data));
            dispatch((0,cart/* validateCart */.ir)(data, function(validateCartData) {
                dispatch((0,order/* placeOrder */.s1)(validateCartData, router));
                dispatch((0,actions_storeInfo/* toggleRfqFormModal */.H4)());
                dispatch((0,cart/* updateRfqDetails */.Fo)(INITIAL_RFQ_FORM_STATE));
            }));
        }));
    };
    var shouldShowQuantityField = function() {
        var quantityObj = b2bRfqInputFields === null || b2bRfqInputFields === void 0 ? void 0 : b2bRfqInputFields.find(function(input) {
            return input.key === "quantity_flag";
        });
        return quantityObj === null || quantityObj === void 0 ? void 0 : quantityObj.is_field_selected;
    };
    var handleInputChange = function(key, value) {
        var rfqFormStateCopy = (0,_object_spread/* default */.Z)({}, rfqFormState);
        if (key === "date_and_time") {
            var stringifiedValue = value ? value === null || value === void 0 ? void 0 : value.toString() : null;
            rfqFormStateCopy[key] = stringifiedValue;
        } else if (key === "phone") {
            rfqFormStateCopy[key] = value.replace(/[^0-9]/g, "").slice(0, 10);
        } else if (key === "custom_message") {
            rfqFormStateCopy[key] = value.slice(0, 500);
        } else if (key == "gst") {
            rfqFormStateCopy[key] = value.slice(0, 15);
        } else {
            rfqFormStateCopy[key] = value.slice(0, 100);
        }
        setRfqFormState(rfqFormStateCopy);
    };
    var isQuantityMandatory = function() {
        var quantityObj = b2bRfqInputFields === null || b2bRfqInputFields === void 0 ? void 0 : b2bRfqInputFields.find(function(input) {
            return input.key === "quantity_flag";
        });
        return quantityObj === null || quantityObj === void 0 ? void 0 : quantityObj.is_mandatory;
    };
    var handleQuantityChange = function(item, value, variant) {
        if (Number(value) <= 99999) {
            if (variant) {
                (0,handleB2bCart/* handleB2bCart */.h)(item, variant, "ADD", null, Number(value));
            } else {
                (0,handleB2bCart/* handleB2bCart */.h)(item, null, "ADD", null, Number(value));
            }
        }
    };
    var handleClose = function() {
        dispatch((0,cart/* updateRfqDetails */.Fo)(rfqFormState));
        dispatch((0,cart/* setCart */.RV)((0,_object_spread/* default */.Z)({}, cartData)));
        dispatch((0,actions_storeInfo/* toggleRfqFormModal */.H4)());
    };
    var handleAddMoreProductsClick = function() {
        var ref;
        handleClose();
        var productData = props === null || props === void 0 ? void 0 : props.productData;
        if (Object.values(productData).length > 0) {
            var ref1, ref2, ref3;
            if ((productData === null || productData === void 0 ? void 0 : (ref1 = productData.collections) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                var ref4, ref5, ref6;
                router.push((0,routes.getRoute)("".concat(routes.PATH.collectionCategories((ref4 = productData.collections[0]) === null || ref4 === void 0 ? void 0 : ref4.id), "?cid=").concat((productData === null || productData === void 0 ? void 0 : (ref5 = productData.category) === null || ref5 === void 0 ? void 0 : ref5.id) || 0), storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.store_info) === null || ref6 === void 0 ? void 0 : ref6.domain), undefined, {
                    shallow: true,
                    scroll: true
                });
                return;
            } else if ((productData === null || productData === void 0 ? void 0 : (ref2 = productData.category) === null || ref2 === void 0 ? void 0 : ref2.id) || (productData === null || productData === void 0 ? void 0 : (ref3 = productData.category) === null || ref3 === void 0 ? void 0 : ref3.id) === 0) {
                var ref7, ref8;
                router.push((0,routes.getRoute)("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : ref7.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat(productData.category.id), storeInfo === null || storeInfo === void 0 ? void 0 : (ref8 = storeInfo.store_info) === null || ref8 === void 0 ? void 0 : ref8.domain), undefined, {
                    shallow: true
                });
                return;
            }
        }
        router.push((0,routes.getRoute)(routes.PATH.DOMAIN_HOME, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var handleRemoveBtnClick = function(item, clickedVariant) {
        if (clickedVariant) {
            (0,handleB2bCart/* handleB2bCart */.h)(item, clickedVariant, "REMOVE", null, null);
        } else {
            (0,handleB2bCart/* handleB2bCart */.h)(item, null, "REMOVE", null, null);
        }
    };
    if (isMobile) {
        var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            visible: openRfqFormModal,
            className: "bottom-modal",
            animation: "slideUp",
            onClose: handleClose,
            closeMaskOnClick: false,
            customStyles: {
                overflowY: "auto"
            },
            children: (cartData === null || cartData === void 0 ? void 0 : (ref10 = cartData.items) === null || ref10 === void 0 ? void 0 : ref10.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (B2b_module_default()).b2bMobileRfqFormContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "/assets/icons/close-icon.svg",
                        alt: "cancel",
                        className: (B2b_module_default()).closeIcon,
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-column justify-center items-center",
                        style: {
                            paddingTop: 117,
                            paddingBottom: 140
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ZeroCart/* ZeroCart */.N, {
                                height: deviceWidth/* deviceWidth */.o >= 767 ? 184.32 : 123,
                                width: deviceWidth/* deviceWidth */.o >= 767 ? 226.77 : 151
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mv0 tc",
                                style: {
                                    fontSize: 14,
                                    paddingTop: 24
                                },
                                children: "Your cart is empty, Go ahead and add something to the cart"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (B2b_module_default()).addItemsBtn,
                                onClick: handleAddMoreProductsClick,
                                style: {
                                    backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref11 = storeInfo.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color,
                                    borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref13 = storeInfo.theme) === null || ref13 === void 0 ? void 0 : ref13.roundness),
                                    marginTop: 22
                                },
                                children: "Add Items"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (B2b_module_default()).b2bMobileRfqFormContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (B2b_module_default()).productsLabel,
                        children: "Products"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "/assets/icons/close-icon.svg",
                        alt: "cancel",
                        className: (B2b_module_default()).closeIcon,
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-column mt16px",
                        children: cartData === null || cartData === void 0 ? void 0 : (ref14 = cartData.items) === null || ref14 === void 0 ? void 0 : ref14.map(function(item, idx) {
                            var ref;
                            if (Array.isArray(item.variants_selected) && !!((ref = item.variants_selected) === null || ref === void 0 ? void 0 : ref.length)) {
                                var ref1;
                                return (ref1 = item.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.map(function(variant) {
                                    var ref, ref1, ref2, ref3;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex justify-between mt16px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex mt12px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (variant === null || variant === void 0 ? void 0 : variant.images) && (variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url) || (variant === null || variant === void 0 ? void 0 : variant.thumbnail_url) || constants/* DEFAULT_IMAGE_URL */.TL,
                                                            width: "48px",
                                                            height: "48px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-column",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center ml16px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: (B2b_module_default()).productName,
                                                                            children: item === null || item === void 0 ? void 0 : item.item_name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-wrap items-center pl4px",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (B2b_module_default()).variantName,
                                                                                    children: "("
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (B2b_module_default()).variantName,
                                                                                    children: variant === null || variant === void 0 ? void 0 : variant.variant_name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (B2b_module_default()).variantName,
                                                                                    children: ")"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: (B2b_module_default()).removeBtn,
                                                                    onClick: function() {
                                                                        return handleRemoveBtnClick(item, variant);
                                                                    },
                                                                    children: "Remove"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            shouldShowQuantityField() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (B2b_module_default()).minQuantityInputContainer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                                                        autoComplete: "off",
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "mv0",
                                                            style: {
                                                                fontFamily: "Montserrat"
                                                            },
                                                            children: "Quantity"
                                                        }),
                                                        required: isQuantityMandatory(),
                                                        inputProps: {
                                                            style: {
                                                                fontFamily: "Montserrat",
                                                                fontWeight: 400,
                                                                fontSize: 14,
                                                                fontStyle: "normal"
                                                            }
                                                        },
                                                        error: (variant === null || variant === void 0 ? void 0 : variant.quantity) < ((variant === null || variant === void 0 ? void 0 : (ref2 = variant.b2b_pricing_info) === null || ref2 === void 0 ? void 0 : ref2.minimum_order_quantity) || 1),
                                                        value: (variant === null || variant === void 0 ? void 0 : variant.quantity) === 0 ? "" : variant === null || variant === void 0 ? void 0 : variant.quantity,
                                                        type: "number",
                                                        onChange: function(e) {
                                                            handleQuantityChange(item, e.target.value.replace(ONLY_NUMERIC_TYPE, ""), variant);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: (B2b_module_default()).minQuantityLabel,
                                                        children: [
                                                            "Minimum Quantity:",
                                                            " ",
                                                            (variant === null || variant === void 0 ? void 0 : (ref3 = variant.b2b_pricing_info) === null || ref3 === void 0 ? void 0 : ref3.minimum_order_quantity) || 1
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }, variant.variant_id);
                                });
                            } else {
                                var ref2, ref3;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-between mt16px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex mt12px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (item === null || item === void 0 ? void 0 : item.image_url) || (item === null || item === void 0 ? void 0 : item.thumbnail_url) || constants/* DEFAULT_IMAGE_URL */.TL,
                                                        width: "48px",
                                                        height: "48px"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-column",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex flex-wrap items-center ml16px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: (B2b_module_default()).productName,
                                                                    children: item === null || item === void 0 ? void 0 : item.item_name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: (B2b_module_default()).removeBtn,
                                                                onClick: function() {
                                                                    return handleRemoveBtnClick(item);
                                                                },
                                                                children: "Remove"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        shouldShowQuantityField() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (B2b_module_default()).minQuantityInputContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                                                    autoComplete: "off",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mv0",
                                                        style: {
                                                            fontFamily: "Montserrat"
                                                        },
                                                        children: "Quantity"
                                                    }),
                                                    required: isQuantityMandatory(),
                                                    inputProps: {
                                                        style: {
                                                            fontFamily: "Montserrat",
                                                            fontWeight: 400,
                                                            fontSize: 14,
                                                            fontStyle: "normal"
                                                        }
                                                    },
                                                    error: (item === null || item === void 0 ? void 0 : item.quantity) < ((item === null || item === void 0 ? void 0 : (ref2 = item.b2b_pricing_info) === null || ref2 === void 0 ? void 0 : ref2.minimum_order_quantity) || 1),
                                                    value: (item === null || item === void 0 ? void 0 : item.quantity) === 0 ? "" : item === null || item === void 0 ? void 0 : item.quantity,
                                                    type: "number",
                                                    onChange: function(e) {
                                                        return handleQuantityChange(item, e.target.value.replace(ONLY_NUMERIC_TYPE, ""));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: (B2b_module_default()).minQuantityLabel,
                                                    children: [
                                                        "Minimum Quantity:",
                                                        " ",
                                                        (item === null || item === void 0 ? void 0 : (ref3 = item.b2b_pricing_info) === null || ref3 === void 0 ? void 0 : ref3.minimum_order_quantity) || 1
                                                    ]
                                                })
                                            ]
                                        }) : null
                                    ]
                                }, idx);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                onClick: handleAddMoreProductsClick,
                                className: (B2b_module_default()).addMoreProducts,
                                children: "Add more products"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (B2b_module_default()).fillDetailsLabel,
                                children: "Please fill your details"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-column",
                                children: b2bRfqInputFields.map(function(inputField) {
                                    if (inputField.key === "quantity_flag") {
                                        return null;
                                    }
                                    if (inputField.is_field_selected && inputField.key === "date_time_flag") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                                    dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDateTimePicker, {
                                                        minDate: dayjs_min_default()(new Date()),
                                                        label: "Date and Time",
                                                        value: dayjs_min_default()(rfqFormState[inputField.payload_key]),
                                                        onChange: function(newValue) {
                                                            return handleInputChange(inputField.payload_key, newValue);
                                                        }
                                                    })
                                                }),
                                                rfqFormState[inputField.payload_key] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        position: "relative"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {
                                                        onClick: function() {
                                                            return handleInputChange(inputField.payload_key, null);
                                                        },
                                                        style: {
                                                            position: "absolute",
                                                            top: "-35px",
                                                            right: "10px",
                                                            cursor: "pointer"
                                                        }
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (B2b_module_default()).preferredDateTimeLabel,
                                                    children: "preferred date and time to discuss"
                                                })
                                            ]
                                        });
                                    }
                                    if (inputField.is_field_selected) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                                            autoComplete: "off",
                                            className: (B2b_module_default()).rfqInput,
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mv0",
                                                style: {
                                                    fontFamily: "Montserrat"
                                                },
                                                children: inputField.inputLabel
                                            }),
                                            value: rfqFormState[inputField.payload_key],
                                            onChange: function(e) {
                                                return handleInputChange(inputField.payload_key, e.target.value);
                                            },
                                            required: inputField.is_mandatory,
                                            inputProps: {
                                                style: {
                                                    height: "18px",
                                                    fontFamily: "Montserrat",
                                                    fontWeight: 400,
                                                    fontSize: 14,
                                                    fontStyle: "normal"
                                                }
                                            },
                                            type: inputField.key === "email" ? "email" : "string"
                                        }, inputField.key);
                                    }
                                    return null;
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end",
                        style: {
                            paddingBottom: 20
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (B2b_module_default()).submitBtn,
                            onClick: handleSubmitBtnClick,
                            style: {
                                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref15 = storeInfo.theme) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.colors) === null || ref16 === void 0 ? void 0 : ref16.primary_color,
                                borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref17 = storeInfo.theme) === null || ref17 === void 0 ? void 0 : ref17.roundness)
                            },
                            children: "Submit"
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: openRfqFormModal,
        className: "bottom-modal",
        animation: "center",
        onClose: handleClose,
        closeMaskOnClick: false,
        customStyles: {
            height: "600px",
            overflowY: "auto",
            borderRadius: "10px"
        },
        children: (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (B2b_module_default()).b2bRfqFormContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "/assets/icons/close-icon.svg",
                    alt: "cancel",
                    className: (B2b_module_default()).closeIcon,
                    onClick: handleClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-column justify-center items-center",
                    style: {
                        paddingTop: 60
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZeroCart/* ZeroCart */.N, {
                            height: deviceWidth/* deviceWidth */.o >= 767 ? 184.32 : 123,
                            width: deviceWidth/* deviceWidth */.o >= 767 ? 226.77 : 151
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mv0 tc",
                            style: {
                                fontSize: 16,
                                paddingTop: 24
                            },
                            children: [
                                "Your cart is empty, Go ahead and add something to ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " the cart"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (B2b_module_default()).addItemsBtn,
                            onClick: handleAddMoreProductsClick,
                            style: {
                                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color,
                                borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : ref3.roundness),
                                marginTop: 36
                            },
                            children: "Add Items"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (B2b_module_default()).b2bRfqFormContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        minHeight: 495
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (B2b_module_default()).productsLabel,
                            children: "Products"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "/assets/icons/close-icon.svg",
                            alt: "cancel",
                            className: (B2b_module_default()).closeIcon,
                            onClick: handleClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-column mt16px",
                            children: cartData === null || cartData === void 0 ? void 0 : (ref4 = cartData.items) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, idx) {
                                var ref;
                                if (Array.isArray(item.variants_selected) && !!((ref = item.variants_selected) === null || ref === void 0 ? void 0 : ref.length)) {
                                    var ref1;
                                    return (ref1 = item.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.map(function(variant) {
                                        var ref, ref1, ref2, ref3;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between mt16px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex mt12px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (variant === null || variant === void 0 ? void 0 : variant.images) && (variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url) || (variant === null || variant === void 0 ? void 0 : variant.thumbnail_url) || constants/* DEFAULT_IMAGE_URL */.TL,
                                                            width: "48px",
                                                            height: "48px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-column",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-wrap items-center ml16px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: (B2b_module_default()).productName,
                                                                            children: item === null || item === void 0 ? void 0 : item.item_name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-wrap items-center pl4px",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (B2b_module_default()).variantName,
                                                                                    children: "("
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (B2b_module_default()).variantName,
                                                                                    children: variant === null || variant === void 0 ? void 0 : variant.variant_name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (B2b_module_default()).variantName,
                                                                                    children: ")"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: (B2b_module_default()).removeBtn,
                                                                    onClick: function() {
                                                                        return handleRemoveBtnClick(item, variant);
                                                                    },
                                                                    children: "Remove"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                shouldShowQuantityField() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (B2b_module_default()).minQuantityInputContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                                                            autoComplete: "off",
                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "mv0",
                                                                style: {
                                                                    fontFamily: "Montserrat"
                                                                },
                                                                children: "Quantity"
                                                            }),
                                                            required: isQuantityMandatory(),
                                                            inputProps: {
                                                                style: {
                                                                    fontFamily: "Montserrat",
                                                                    fontWeight: 400,
                                                                    fontSize: 14,
                                                                    fontStyle: "normal"
                                                                }
                                                            },
                                                            error: (variant === null || variant === void 0 ? void 0 : variant.quantity) < ((variant === null || variant === void 0 ? void 0 : (ref2 = variant.b2b_pricing_info) === null || ref2 === void 0 ? void 0 : ref2.minimum_order_quantity) || 1),
                                                            value: (variant === null || variant === void 0 ? void 0 : variant.quantity) === 0 ? "" : variant === null || variant === void 0 ? void 0 : variant.quantity,
                                                            type: "number",
                                                            onChange: function(e) {
                                                                return handleQuantityChange(item, e.target.value.replace(ONLY_NUMERIC_TYPE, ""), variant);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (B2b_module_default()).minQuantityLabel,
                                                            children: [
                                                                "Minimum Quantity:",
                                                                " ",
                                                                (variant === null || variant === void 0 ? void 0 : (ref3 = variant.b2b_pricing_info) === null || ref3 === void 0 ? void 0 : ref3.minimum_order_quantity) || 1
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }, variant.variant_id);
                                    });
                                } else {
                                    var ref2, ref3;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between mt16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex mt12px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (item === null || item === void 0 ? void 0 : item.image_url) || (item === null || item === void 0 ? void 0 : item.thumbnail_url) || constants/* DEFAULT_IMAGE_URL */.TL,
                                                        width: "48px",
                                                        height: "48px"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-column",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex flex-wrap items-center ml16px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: (B2b_module_default()).productName,
                                                                    children: item === null || item === void 0 ? void 0 : item.item_name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: (B2b_module_default()).removeBtn,
                                                                onClick: function() {
                                                                    return handleRemoveBtnClick(item);
                                                                },
                                                                children: "Remove"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            shouldShowQuantityField() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (B2b_module_default()).minQuantityInputContainer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                                                        autoComplete: "off",
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "mv0",
                                                            style: {
                                                                fontFamily: "Montserrat"
                                                            },
                                                            children: "Quantity"
                                                        }),
                                                        required: isQuantityMandatory(),
                                                        inputProps: {
                                                            style: {
                                                                fontFamily: "Montserrat",
                                                                fontWeight: 400,
                                                                fontSize: 14,
                                                                fontStyle: "normal"
                                                            }
                                                        },
                                                        error: (item === null || item === void 0 ? void 0 : item.quantity) < ((item === null || item === void 0 ? void 0 : (ref2 = item.b2b_pricing_info) === null || ref2 === void 0 ? void 0 : ref2.minimum_order_quantity) || 1),
                                                        value: (item === null || item === void 0 ? void 0 : item.quantity) === 0 ? "" : item === null || item === void 0 ? void 0 : item.quantity,
                                                        type: "number",
                                                        onChange: function(e) {
                                                            return handleQuantityChange(item, e.target.value.replace(ONLY_NUMERIC_TYPE, ""));
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: (B2b_module_default()).minQuantityLabel,
                                                        children: [
                                                            "Minimum Quantity:",
                                                            " ",
                                                            (item === null || item === void 0 ? void 0 : (ref3 = item.b2b_pricing_info) === null || ref3 === void 0 ? void 0 : ref3.minimum_order_quantity) || 1
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }, idx);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: handleAddMoreProductsClick,
                                    className: (B2b_module_default()).addMoreProducts,
                                    children: "Add more products"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: (B2b_module_default()).fillDetailsLabel,
                                    children: "Please fill your details"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-column",
                                    children: b2bRfqInputFields === null || b2bRfqInputFields === void 0 ? void 0 : b2bRfqInputFields.map(function(inputField) {
                                        if (inputField.key === "quantity_flag") {
                                            return null;
                                        }
                                        if (inputField.is_field_selected && inputField.key === "date_time_flag") {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                                        dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDateTimePicker, {
                                                            minDate: dayjs_min_default()(new Date()),
                                                            label: "Date and Time",
                                                            value: dayjs_min_default()(rfqFormState[inputField.payload_key]),
                                                            onChange: function(newValue) {
                                                                return handleInputChange(inputField.payload_key, newValue);
                                                            }
                                                        })
                                                    }),
                                                    rfqFormState[inputField.payload_key] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            position: "relative"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {
                                                            onClick: function() {
                                                                return handleInputChange(inputField.payload_key, null);
                                                            },
                                                            style: {
                                                                position: "absolute",
                                                                top: "-35px",
                                                                right: "10px",
                                                                cursor: "pointer"
                                                            }
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (B2b_module_default()).preferredDateTimeLabel,
                                                        children: "preferred date and time to discuss"
                                                    })
                                                ]
                                            });
                                        }
                                        if (inputField.is_field_selected) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                                                autoComplete: "off",
                                                className: (B2b_module_default()).rfqInput,
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mv0",
                                                    style: {
                                                        fontFamily: "Montserrat"
                                                    },
                                                    children: inputField.inputLabel
                                                }),
                                                value: rfqFormState[inputField.payload_key],
                                                onChange: function(e) {
                                                    return handleInputChange(inputField.payload_key, e.target.value);
                                                },
                                                inputProps: {
                                                    style: {
                                                        height: "18px",
                                                        fontFamily: "Montserrat",
                                                        fontWeight: 400,
                                                        fontSize: 14,
                                                        fontStyle: "normal"
                                                    }
                                                },
                                                required: inputField.is_mandatory,
                                                type: inputField.key === "email" ? "email" : "string"
                                            }, inputField.key);
                                        }
                                        return null;
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (B2b_module_default()).submitBtn,
                        onClick: handleSubmitBtnClick,
                        style: {
                            backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color,
                            borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : ref7.roundness)
                        },
                        children: "Submit"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 596930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ canDisablePlaceOrder; }
/* harmony export */ });
/* harmony import */ var src_redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);
/* harmony import */ var src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40804);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(506337);





var canDisablePlaceOrder = function() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        showMessage: true,
        message: "This is a demo website, you need a live version to proceed this action."
    };
    var ref, ref1, ref2, ref3, // for new stores
    ref4, // for old stores
    ref5;
    var showMessage = args.showMessage, message = args.message;
    var storeInfo = (ref = src_redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : ref1.store;
    // Disable place order flow for play preview URLs.
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__/* .IS_CLIENT */ .kc && ((ref2 = window.location.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW))) {
        return true;
    }
    // Enable place order flow for stores having theme and staging environment.
    if ( false || !!(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.premium)) {
        return false;
    }
    var disablePlaceOrder = ((ref3 = window.location.pathname) === null || ref3 === void 0 ? void 0 : ref3.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW)) || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.new_subscription_web_status) === src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_STORE_WEBSITE_STATUS.ACTIVE_NOT_LIVE */ .d6.ACTIVE_NOT_LIVE || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.domain_info) === null || ref5 === void 0 ? void 0 : ref5.domain_type) === 0;
    if (disablePlaceOrder && showMessage && (message === null || message === void 0 ? void 0 : message.trim())) {
        (0,src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__/* .toastNotifyError */ .Lu)(message);
    }
    return disablePlaceOrder;
};


/***/ }),

/***/ 471822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ handleB2bCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(666162);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);




function handleB2bCart(clickedItem, activeVariant, type, minimumOrderQuantity, quantityEnteredByUser) {
    clickedItem = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, clickedItem), {
        item_name: clickedItem.name,
        actual_price: 0,
        item_price: 0,
        amount: 0,
        actual_amount: 0,
        discounted_price: 0,
        item_id: clickedItem.id || clickedItem.item_id,
        buyer_pay_value: 0,
        item_type: "catalog"
    });
    var b2bCartItems = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer.items;
    if (activeVariant) {
        if (type === "ADD") {
            var itemAlreadyExistsInCartIndex = b2bCartItems.findIndex(function(item) {
                return item.item_id === clickedItem.item_id;
            });
            if (itemAlreadyExistsInCartIndex !== -1) {
                var doesVariantAlreadyExistsInCartIndex = b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected.findIndex(function(variant) {
                    return variant.variant_id === activeVariant.variant_id;
                });
                if (doesVariantAlreadyExistsInCartIndex !== -1) {
                    var ref;
                    b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected[doesVariantAlreadyExistsInCartIndex].quantity = quantityEnteredByUser !== null && quantityEnteredByUser !== void 0 ? quantityEnteredByUser : b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected[doesVariantAlreadyExistsInCartIndex].quantity;
                    var itemQuantityWithoutCurrentVariant = 0;
                    (ref = b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected) === null || ref === void 0 ? void 0 : ref.forEach(function(variant) {
                        if (variant.variant_id !== b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected[doesVariantAlreadyExistsInCartIndex].variant_id) {
                            itemQuantityWithoutCurrentVariant = itemQuantityWithoutCurrentVariant + variant.quantity;
                        }
                    });
                    b2bCartItems[itemAlreadyExistsInCartIndex].quantity = itemQuantityWithoutCurrentVariant + b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected[doesVariantAlreadyExistsInCartIndex].quantity;
                } else {
                    var ref1;
                    activeVariant.quantity = minimumOrderQuantity || 1;
                    b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected.push(activeVariant);
                    var itemQuantityWithoutCurrentVariant1 = 0;
                    (ref1 = b2bCartItems[itemAlreadyExistsInCartIndex].variants_selected) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(variant) {
                        if (variant.variant_id !== activeVariant.variant_id) {
                            itemQuantityWithoutCurrentVariant1 = itemQuantityWithoutCurrentVariant1 + variant.quantity;
                        }
                    });
                    b2bCartItems[itemAlreadyExistsInCartIndex].quantity = itemQuantityWithoutCurrentVariant1 + activeVariant.quantity;
                }
            } else {
                activeVariant.quantity = minimumOrderQuantity || 1;
                clickedItem.variants_selected = [
                    activeVariant
                ];
                clickedItem.quantity = minimumOrderQuantity || 1;
                b2bCartItems.push(clickedItem);
            }
            _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .updateB2bCart */ .vH)(b2bCartItems));
        } else {
            var itemAlreadyExistsInCartIndex1 = b2bCartItems.findIndex(function(item) {
                return item.item_id === clickedItem.item_id;
            });
            var filteredVariantItems = b2bCartItems[itemAlreadyExistsInCartIndex1].variants_selected.filter(function(variant) {
                return variant.variant_id !== activeVariant.variant_id;
            });
            if (filteredVariantItems.length) {
                b2bCartItems[itemAlreadyExistsInCartIndex1].variants_selected = filteredVariantItems;
                _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .updateB2bCart */ .vH)(b2bCartItems));
            } else {
                var filteredB2bCartItems = b2bCartItems.filter(function(item) {
                    return item.item_id !== clickedItem.item_id;
                });
                _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .updateB2bCart */ .vH)(filteredB2bCartItems));
            }
        }
    } else {
        if (type === "ADD") {
            var itemAlreadyExistsInCart = b2bCartItems.find(function(item) {
                return item.item_id === clickedItem.item_id;
            });
            if (itemAlreadyExistsInCart) {
                b2bCartItems.forEach(function(item) {
                    if (item.item_id === itemAlreadyExistsInCart.item_id) {
                        item.quantity = quantityEnteredByUser !== null && quantityEnteredByUser !== void 0 ? quantityEnteredByUser : item.quantity;
                    }
                });
            } else {
                clickedItem.quantity = minimumOrderQuantity || 1;
                b2bCartItems.push(clickedItem);
            }
            _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .updateB2bCart */ .vH)(b2bCartItems));
        } else {
            var filteredB2bCartItems1 = b2bCartItems.filter(function(item) {
                return item.item_id !== clickedItem.item_id;
            });
            _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .updateB2bCart */ .vH)(filteredB2bCartItems1));
        }
    }
}


/***/ }),

/***/ 206723:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"b2bRequestForBtnContainer":"B2b_b2bRequestForBtnContainer__U5O32","btn":"B2b_btn__yQ4MY","b2bRequestForQuoteMobileBtn":"B2b_b2bRequestForQuoteMobileBtn__xpzaY","b2bRfqFormContainer":"B2b_b2bRfqFormContainer__V4s48","productsLabel":"B2b_productsLabel__TXuwK","closeIcon":"B2b_closeIcon__iWzYO","productName":"B2b_productName__ei48h","variantName":"B2b_variantName__0bhrF","removeBtn":"B2b_removeBtn__B2E4C","minQuantityInputContainer":"B2b_minQuantityInputContainer__XEWZ0","minQuantityLabel":"B2b_minQuantityLabel__5v5V7","addMoreProducts":"B2b_addMoreProducts__8ft8n","fillDetailsLabel":"B2b_fillDetailsLabel__RzeV_","preferredDateTimeLabel":"B2b_preferredDateTimeLabel__bo5mz","rfqInput":"B2b_rfqInput__UYRrn","submitBtn":"B2b_submitBtn___ncAk","addItemsBtn":"B2b_addItemsBtn__t13ib","b2bMobileRfqFormContainer":"B2b_b2bMobileRfqFormContainer__kfZC5"};

/***/ })

}]);